import React, { useState, useEffect, useRef, Component } from 'react';
import './App.css';
import { supabase, setModoSoloLectura, setOnBloqueo } from './supabase';
import { useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import { UserContext } from './UserContext';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Expedientes from './pages/Expedientes';
import Tramites from './pages/Tramites';
import Agenda from './pages/Agenda';
import Configuracion from './pages/Configuracion';
import Personalizacion from './pages/Personalizacion';
import Asignaciones from './pages/Asignaciones';
import Contable from './pages/Contable';
import EspacioDeTrabajo from './pages/EspacioDeTrabajo';
import Papelera from './pages/Papelera';
import GestionUsuarios from './pages/GestionUsuarios';
import ConfigurarContrasena from './components/ConfigurarContrasena';
import GoogleCalendarSync from './components/GoogleCalendarSync';
import Pago from './pages/Pago';
import Admin from './pages/Admin';

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { crashed: false }; }
  static getDerivedStateFromError() { return { crashed: true }; }
  componentDidCatch(error) { console.error('App crash:', error); }
  render() {
    if (this.state.crashed) return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 16, background: '#f9fafb' }}>
        <div style={{ fontSize: 40 }}>⚠️</div>
        <div style={{ fontSize: 18, fontWeight: 600, color: '#1e293b' }}>Algo salió mal</div>
        <div style={{ fontSize: 13, color: '#64748b', textAlign: 'center', maxWidth: 320 }}>
          Una extensión del navegador puede estar causando este error.<br/>
          Intentá recargar la página o usá el modo incógnito.
        </div>
        <button onClick={() => window.location.reload()} style={{ padding: '10px 28px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
          Recargar página
        </button>
      </div>
    );
    return this.props.children;
  }
}

const NAV_ITEMS = [
  { id: 'dashboard',      label: 'Panel general',            section: 'Vista general del estudio', adminOnly: false },
  { id: 'workspace',      label: 'Espacio de trabajo',       section: 'Principal', adminOnly: false },
  { id: 'agenda',         label: 'Agenda y Calendario',      section: null,        adminOnly: false },
  { id: 'asignaciones',   label: 'Asignación de tareas',     section: null,        adminOnly: false },
  { id: 'clientes',       label: 'Clientes',                 section: 'Gestión',   adminOnly: false },
  { id: 'expedientes',    label: 'Expedientes',              section: null,        adminOnly: false },
  { id: 'tramites',       label: 'Trámites Extrajudiciales', section: null,        adminOnly: false },
  { id: 'contable',       label: 'Contabilidad del estudio', section: 'Contable',  adminOnly: true  },
  { id: 'gestionusuarios',label: 'Gestión de usuarios',      section: 'Sistema',   adminOnly: true  },
  { id: 'papelera',       label: 'Papelera de reciclaje',    section: null,        adminOnly: true  },
  { id: 'personalizacion',label: 'Personalización',          section: null,        adminOnly: true  },
  { id: 'configuracion',  label: 'Configuración',            section: null,        adminOnly: false },
  { id: 'suscripcion',    label: 'Suscripción',              section: null,        adminOnly: true  },
  { id: 'admin',          label: 'Panel de control',         section: 'Superadmin',adminOnly: false, superadminOnly: true },
];

const PAGES = {
  dashboard: Dashboard, workspace: EspacioDeTrabajo, clientes: Clientes,
  expedientes: Expedientes, tramites: Tramites, agenda: Agenda,
  contable: Contable, asignaciones: Asignaciones, personalizacion: Personalizacion,
  configuracion: Configuracion, gestionusuarios: GestionUsuarios, papelera: Papelera,
  suscripcion: Pago, admin: Admin,
};

function ModalNuevaContrasena({ onListo }) {
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  async function guardar(e) {
    e.preventDefault();
    if (pass.length < 6) { setError('La contraseña debe tener al menos 6 caracteres.'); return; }
    if (pass !== pass2) { setError('Las contraseñas no coinciden.'); return; }
    setGuardando(true);
    const { error: authErr } = await supabase.auth.updateUser({ password: pass });
    if (authErr) { setError('Error: ' + authErr.message); setGuardando(false); return; }
    setGuardando(false);
    onListo();
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 14, padding: '36px 32px', width: 360, boxShadow: '0 16px 48px rgba(0,0,0,0.2)' }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>Nueva contraseña</div>
        <div style={{ fontSize: 13, color: 'var(--text4)', marginBottom: 24 }}>Elegí una nueva contraseña para tu cuenta.</div>
        <form onSubmit={guardar}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: 'var(--text)', marginBottom: 6 }}>Nueva contraseña</label>
            <input className="form-input" type="password" value={pass} onChange={e => setPass(e.target.value)} placeholder="Mínimo 6 caracteres" required autoFocus />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: 'var(--text)', marginBottom: 6 }}>Repetir contraseña</label>
            <input className="form-input" type="password" value={pass2} onChange={e => setPass2(e.target.value)} placeholder="••••••••" required />
          </div>
          {error && <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', color: '#dc2626', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>{error}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', height: 42, fontSize: 14 }} disabled={guardando}>
            {guardando ? 'Guardando...' : 'Guardar contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}

// Días de tolerancia tras el vencimiento antes de pasar a solo-lectura.
// Durante la gracia la app sigue editable, con aviso; al terminarla se corta.
const GRACE_DIAS = 5;
const finGracia = (fecha) => new Date(new Date(fecha).getTime() + GRACE_DIAS * 24 * 60 * 60 * 1000);

// Única fuente de verdad de "¿está vencida la suscripción?" — la usan tanto
// el render (banner + modo lectura) como el efecto que prende el candado en
// el wrapper de supabase. Superadmin (dueño de la plataforma) nunca se
// bloquea. suscripcion === undefined = todavía cargando: no bloquear.
function suscripcionVencida(suscripcion, esSuperadmin) {
  if (esSuperadmin) return false;
  if (suscripcion === undefined) return false;
  const s = suscripcion;
  if (!s) return true; // sin fila de suscripción: fail-closed
  const ahora = new Date();
  if (s.estado === 'trial')  return s.trial_hasta ? ahora > finGracia(s.trial_hasta) : true;
  if (s.estado === 'activa') return s.periodo_fin ? ahora > finGracia(s.periodo_fin) : false;
  return true; // vencida / cancelada / desconocido
}

export default function AppShell() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState(() => localStorage.getItem('activePage') || 'dashboard');
  const [navTab, setNavTab] = useState('panel');
  const [session, setSession] = useState(undefined);
  const [perfil, setPerfil] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const creandoEstudioRef = useRef(false);
  const [recoveryMode, setRecoveryMode] = useState(false);
  const [suscripcion, setSuscripcion] = useState(undefined);
  const [bloqueoToast, setBloqueoToast] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const CONTABLE_ALIASES = { ingresos: 'ingresos', gastos: 'gastos', deudas: 'deudas', panel_contable: 'panel' };
  function handleNavigate(page, tab) {
    let target = page, t = tab;
    if (CONTABLE_ALIASES[page]) { target = 'contable'; t = CONTABLE_ALIASES[page]; }
    setActivePage(target);
    localStorage.setItem('activePage', target);
    if (t) setNavTab(t);
    setSidebarOpen(false); // en mobile el sidebar es un cajón; cerrar al navegar
  }

  // Vuelta del flujo de autorizacion de Google Calendar: /app?google=conectado|cancelado|error.
  // Se deja el resultado para Configuracion, se limpia la URL y se lleva al usuario ahi.
  useEffect(() => {
    const resultado = new URLSearchParams(window.location.search).get('google');
    if (!resultado) return;
    sessionStorage.setItem('gcal_flash', resultado);
    window.history.replaceState({}, '', window.location.pathname);
    setActivePage('configuracion');
    localStorage.setItem('activePage', 'configuracion');
  }, []);

  async function cambiarEstudio(nuevoEstudioId) {
    if (!session) return;
    await supabase.from('profiles').update({ estudio_activo_id: nuevoEstudioId }).eq('id', session.user.id);
    setActivePage('dashboard');
    localStorage.setItem('activePage', 'dashboard');
    setRefreshKey(k => k + 1);
  }

  useEffect(() => {
    // Detectar flujo de recovery tanto por hash (implicit) como por evento (PKCE)
    const hash = window.location.hash;
    if (hash && hash.includes('type=recovery')) {
      setRecoveryMode(true);
    }

    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') setRecoveryMode(true);
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!session) { setPerfil(null); return; }

    async function cargarPerfil() {
      const nombreDefault = session.user.email?.split('@')[0] || 'Usuario';
      const emailActual   = session.user.email || '';

      const { data } = await supabase
        .from('profiles')
        .select('nombre, email, activo, contrasena_configurada, estudio_activo_id, superadmin')
        .eq('id', session.user.id)
        .single();

      if (!data) {
        const meta = session.user.user_metadata || {};
        const invitadoEstudioId = meta.estudio_id;
        const nombreEstudio = meta.nombre_estudio;
        const nombreUsuario = meta.nombre || nombreDefault;

        if (nombreEstudio && !invitadoEstudioId) {
          if (creandoEstudioRef.current) return;
          creandoEstudioRef.current = true;
          await supabase.rpc('registrar_nuevo_estudio', {
            p_nombre_estudio: nombreEstudio,
            p_nombre_usuario: nombreUsuario,
          });
          creandoEstudioRef.current = false;
          setRefreshKey(k => k + 1);
          return;
        }

        // Invitado o fallback
        let estudioId = invitadoEstudioId;
        if (!estudioId) {
          const { data: e } = await supabase.from('estudios').select('id').single();
          estudioId = e?.id;
        }
        await supabase.from('profiles').insert({
          id: session.user.id, nombre: nombreUsuario, email: emailActual,
          activo: true, contrasena_configurada: false, estudio_activo_id: estudioId,
        });
        if (estudioId) {
          await supabase.from('estudio_miembros').insert({
            estudio_id: estudioId, user_id: session.user.id, rol: 'colaborador',
          });
        }
        setPerfil({ rol: 'colaborador', nombre: nombreUsuario, email: emailActual,
          activo: true, contrasena_configurada: false, estudio_activo_id: estudioId, estudios: [] });
        return;
      }

      const { data: miembro } = await supabase
        .from('estudio_miembros').select('rol, activo')
        .eq('user_id', session.user.id).eq('estudio_id', data.estudio_activo_id).single();

      if (miembro?.activo === false) { setPerfil({ ...data, revocado: true }); return; }

      const { data: misEstudios } = await supabase
        .from('estudio_miembros').select('estudio_id, rol, estudios(nombre)')
        .eq('user_id', session.user.id).eq('activo', true);

      const updates = {};
      if (!data.nombre) updates.nombre = nombreDefault;
      if (!data.email)  updates.email  = emailActual;
      if (Object.keys(updates).length > 0)
        await supabase.from('profiles').update(updates).eq('id', session.user.id);

      setPerfil({
        ...data,
        nombre: data.nombre || nombreDefault,
        email:  data.email  || emailActual,
        rol:    miembro?.rol || 'colaborador',
        estudios: misEstudios || [],
      });
    }

    cargarPerfil().catch(() => setPerfil({ rol: 'colaborador', nombre: '' }));
  }, [session, refreshKey]);

  useEffect(() => {
    if (!perfil?.estudio_activo_id) return;
    supabase
      .from('suscripciones')
      .select('*')
      .eq('estudio_id', perfil.estudio_activo_id)
      .single()
      .then(({ data }) => setSuscripcion(data || null));
  }, [perfil?.estudio_activo_id, refreshKey]);

  // La suscripción puede cambiar desde afuera de esta sesión (webhook de
  // pago, el panel de superadmin regalando meses desde otra pestaña/cuenta).
  // Sin esto, la sesión abierta se queda con el dato viejo hasta recargar.
  useEffect(() => {
    if (!perfil?.estudio_activo_id) return;
    const canal = supabase
      .channel(`suscripcion-${perfil.estudio_activo_id}`)
      .on('postgres_changes', {
        event: '*', schema: 'public', table: 'suscripciones',
        filter: `estudio_id=eq.${perfil.estudio_activo_id}`,
      }, (payload) => setSuscripcion(payload.new || null))
      .subscribe();
    return () => { supabase.removeChannel(canal); };
  }, [perfil?.estudio_activo_id]);

  // Prende/apaga el candado de solo-lectura en el wrapper de supabase según
  // el estado de la suscripción. Debe ir antes de los early returns para no
  // romper el orden de hooks.
  useEffect(() => {
    setModoSoloLectura(suscripcionVencida(suscripcion, !!perfil?.superadmin));
  }, [suscripcion, perfil?.superadmin]);

  // Muestra un aviso cuando el wrapper corta una escritura por vencimiento.
  useEffect(() => {
    setOnBloqueo(() => setBloqueoToast(true));
    return () => setOnBloqueo(null);
  }, []);

  // Oculta el toast de bloqueo solo tras unos segundos.
  useEffect(() => {
    if (!bloqueoToast) return;
    const t = setTimeout(() => setBloqueoToast(false), 5000);
    return () => clearTimeout(t);
  }, [bloqueoToast]);

  if (recoveryMode) return (
    <ErrorBoundary>
      <ModalNuevaContrasena onListo={() => { setRecoveryMode(false); window.location.hash = ''; }} />
    </ErrorBoundary>
  );

  if (session === undefined) return null;
  if (session && perfil === null) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#64748b', fontSize: 14 }}>
      Cargando...
    </div>
  );
  if (!session) return <Login />;

  if (perfil?.revocado) return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 12, background: '#f9fafb' }}>
      <div style={{ fontSize: 32 }}>🔒</div>
      <div style={{ fontSize: 17, fontWeight: 700, color: '#1e293b' }}>Acceso revocado</div>
      <div style={{ fontSize: 13, color: '#64748b', textAlign: 'center', maxWidth: 300 }}>
        Tu acceso a Mi Estudio fue revocado por el administrador.<br/>Contactalo para reactivar tu cuenta.
      </div>
      <button onClick={() => supabase.auth.signOut().then(() => navigate('/'))}
        style={{ marginTop: 8, padding: '9px 24px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
        Cerrar sesión
      </button>
    </div>
  );

  const rol = perfil?.rol || 'colaborador';
  const esAdmin = rol === 'admin';
  const esSuperadmin = !!perfil?.superadmin;
  const navItems = NAV_ITEMS.filter(i => {
    if (i.superadminOnly) return esSuperadmin;
    if (i.adminOnly) return esAdmin;
    return true;
  });
  const safePage = navItems.find(i => i.id === activePage) ? activePage : 'dashboard';
  const PageComponent = PAGES[safePage];

  const ahora = new Date();
  const modoLectura = suscripcionVencida(suscripcion, esSuperadmin);

  const DIA = 1000 * 60 * 60 * 24;
  const fechaVenc = suscripcion?.estado === 'trial' ? suscripcion?.trial_hasta
    : suscripcion?.estado === 'activa' ? suscripcion?.periodo_fin
    : null;
  const fechaVencD = !esSuperadmin && fechaVenc ? new Date(fechaVenc) : null;
  const vencido = fechaVencD && fechaVencD < ahora;                 // ya venció (en gracia si !modoLectura)
  const diasHastaVenc = fechaVencD ? Math.ceil((fechaVencD - ahora) / DIA) : null;      // días hasta vencer
  const diasHastaCorte = fechaVencD ? Math.ceil((finGracia(fechaVenc) - ahora) / DIA) : null; // días hasta modo lectura

  return (
    <ErrorBoundary>
    <UserContext.Provider value={{ rol, estudioId: perfil?.estudio_activo_id, estudios: perfil?.estudios || [], cambiarEstudio, modoLectura: !!modoLectura, suscripcion }}>
    {perfil && !perfil.contrasena_configurada && (
      <ConfigurarContrasena onListo={() => setPerfil(p => ({ ...p, contrasena_configurada: true }))} />
    )}
    {perfil?.estudio_activo_id && <GoogleCalendarSync estudioId={perfil.estudio_activo_id} />}

    <div className="app-layout">
      <button
        className="mobile-menu-btn"
        aria-label="Abrir menú"
        onClick={() => setSidebarOpen(true)}
      >
        ☰
      </button>
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
      <aside className={`sidebar${sidebarOpen ? ' open' : ''}`}>
        <div className="logo">
          <div className="logo-row">
            <div className="logo-icon" style={{ background: 'transparent', padding: 0 }}>
              <img src="/logo.svg" alt="Mi Estudio Juridico" width="34" height="34" style={{ objectFit: 'contain', display: 'block' }} />
            </div>
            <div>
              <div className="logo-title">Mi Estudio</div>
              <div className="logo-sub">Gestión jurídica integral</div>
            </div>
            <button className="mobile-close-btn" aria-label="Cerrar menú" onClick={() => setSidebarOpen(false)}>✕</button>
          </div>
        </div>
        <nav className="nav">
          {navItems.map((item) => (
            <React.Fragment key={item.id}>
              {item.section && <div className="nav-section">{item.section}</div>}
              <div className={`nav-item ${safePage === item.id ? 'active' : ''}`} onClick={() => handleNavigate(item.id)}>
                <div className="nav-dot" />
                {item.label}
              </div>
            </React.Fragment>
          ))}
        </nav>
        {perfil?.estudios?.length > 1 && (
          <div style={{ padding: '8px 14px', borderTop: '0.5px solid rgba(255,255,255,0.1)' }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>Estudio activo</div>
            {perfil.estudios.map(m => (
              <div key={m.estudio_id} onClick={() => cambiarEstudio(m.estudio_id)} style={{
                padding: '6px 10px', borderRadius: 6, marginBottom: 3, cursor: 'pointer',
                fontSize: 12, fontWeight: m.estudio_id === perfil.estudio_activo_id ? 700 : 400,
                color: m.estudio_id === perfil.estudio_activo_id ? 'white' : 'rgba(255,255,255,0.5)',
                background: m.estudio_id === perfil.estudio_activo_id ? 'rgba(255,255,255,0.12)' : 'transparent',
              }}>
                {m.estudios?.nombre}
              </div>
            ))}
          </div>
        )}
        <div className="sidebar-footer">
          <div className="user-card" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div className="user-avatar">{esAdmin ? 'Dr' : 'Co'}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="user-name">{perfil?.nombre || (esAdmin ? 'Mi Estudio' : 'Colaborador')}</div>
                <div className="user-role">
                  <span>{session.user.email}</span>
                </div>
              </div>
            </div>
            <button
              onClick={() => supabase.auth.signOut().then(() => navigate('/'))}
              style={{ width: '100%', background: '#f1f5f9', border: '1px solid #e2e8f0', color: '#64748b', borderRadius: 6, padding: '6px', fontSize: 12, cursor: 'pointer', fontWeight: 500, transition: 'all 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#1e293b'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#64748b'; }}
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </aside>
      <main className="main-content">
        {modoLectura && safePage !== 'suscripcion' && (
          <div style={{ background: '#dc2626', color: 'white', padding: '10px 20px', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <span>Tu período de prueba terminó. Estás en modo lectura — no podés crear ni editar.</span>
            <button onClick={() => handleNavigate('suscripcion')} style={{ background: 'white', color: '#dc2626', border: 'none', borderRadius: 6, padding: '5px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
              Ver planes →
            </button>
          </div>
        )}
        {!modoLectura && vencido && safePage !== 'suscripcion' && (
          <div style={{ background: '#ea580c', color: 'white', padding: '10px 20px', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <span>Tu prueba venció. {diasHastaCorte <= 0 ? 'Hoy pasás a modo lectura.' : `Te queda${diasHastaCorte === 1 ? '' : 'n'} ${diasHastaCorte} día${diasHastaCorte === 1 ? '' : 's'} de acceso antes de pasar a modo lectura.`} Activá el pago para seguir.</span>
            <button onClick={() => handleNavigate('suscripcion')} style={{ background: 'white', color: '#c2410c', border: 'none', borderRadius: 6, padding: '5px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
              Suscribirme →
            </button>
          </div>
        )}
        {!modoLectura && !vencido && diasHastaVenc !== null && diasHastaVenc <= 3 && safePage !== 'suscripcion' && (
          <div style={{ background: '#f59e0b', color: 'white', padding: '10px 20px', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <span>{diasHastaVenc <= 0 ? 'Tu prueba vence hoy.' : `Te quedan ${diasHastaVenc} día${diasHastaVenc === 1 ? '' : 's'} de prueba.`}</span>
            <button onClick={() => handleNavigate('suscripcion')} style={{ background: 'white', color: '#b45309', border: 'none', borderRadius: 6, padding: '5px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
              Suscribirme →
            </button>
          </div>
        )}
        {safePage === 'suscripcion'
          ? <div style={{ flex: 1, overflowY: 'auto' }}><Pago perfil={perfil} suscripcion={suscripcion} /></div>
          : safePage === 'admin'
          ? <div style={{ flex: 1, overflowY: 'auto' }}><Admin /></div>
          : <PageComponent onNavigate={handleNavigate} initialTab={navTab}
              key={safePage === 'contable' ? `contable-${navTab}` : safePage} />
        }
      </main>

      {bloqueoToast && (
        <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: '#1e293b', color: 'white', padding: '12px 18px', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.25)', display: 'flex', alignItems: 'center', gap: 14, maxWidth: 460 }}>
          <span style={{ fontSize: 13 }}>Tu suscripción venció. Activá el pago para volver a crear o editar.</span>
          <button onClick={() => { setBloqueoToast(false); handleNavigate('suscripcion'); }} style={{ background: '#2563eb', color: 'white', border: 'none', borderRadius: 6, padding: '6px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
            Ver planes
          </button>
        </div>
      )}
    </div>
    </UserContext.Provider>
    </ErrorBoundary>
  );
}
